import {
  CHECKOUT_EMAIL_UPDATE_ERROR,
  IS_UPDATING_BILLING_INFORMATION,
  IS_UPDATING_CONTACT_EMAIL,
  IS_UPDATING_SHIPPING_INFORMATION,
  SET_SHIPPING_METHOD,
  UPDATING_BILLING_INFORMATION_ERROR,
  UPDATING_BILLING_INFORMATION_SUCCESS,
  UPDATING_CONTACT_EMAIL_ERROR,
  UPDATING_CONTACT_EMAIL_SUCCESS,
  UPDATING_SHIPPING_INFORMATION_ERROR,
  UPDATING_SHIPPING_INFORMATION_SUCCESS,
} from "../../constants/ActionTypes";
import { hasAlreadySetShippingAddress, normalizeAddressInformation } from "../../utils/helpers";
import { SAME_AS_BILLING_ADDRESS } from "../../constants/AppConstants";

const INIT_STATE = {
  /**
   * Shipping Information are same as billing by default
   * Because user model has no shipping information
   * we only add new shipping information if front-end user select to use diffrent shipping address on checkout
   */

  billingInformation: {
    first_name: null,
    last_name: null,
    phone: null,
    email: null,
    country: null,
    address_line1: null,
    city: null,
    postal_code: null,
    state: null,
  },
  shippingInformation: {
    first_name: null,
    last_name: null,
    phone: null,
    email: null,
    country: null,
    address_line1: null,
    city: null,
    postal_code: null,
    state: null,
  },
  email: null,
  shippingMethod: null,
  shippingSameAsBilling: !hasAlreadySetShippingAddress(),
  // Error handling And UI states
  isUpdatingBillingInformation: false,
  updateBillingInformationErrors: null,
  isUpdatingShippingInformation: false,
  updateShippingInformationErrors: null,
  updateContactEmailError: null,
  isUpdatingContactEmail: false,
};

export default (state = INIT_STATE, action) => {
  switch (action.type) {
    case IS_UPDATING_CONTACT_EMAIL: {
      return {
        ...state,
        isUpdatingContactEmail: true,
        updateContactEmailError: null,
      };
    }
    case UPDATING_CONTACT_EMAIL_SUCCESS: {
      return {
        ...state,
        email: action.payload,
        isUpdatingContactEmail: false,
        updateContactEmailError: null,
      };
    }
    case UPDATING_CONTACT_EMAIL_ERROR: {
      return {
        ...state,
        isUpdatingContactEmail: false,
        updateContactEmailError: action.payload,
      };
    }
    case IS_UPDATING_BILLING_INFORMATION: {
      return {
        ...state,
        isUpdatingBillingInformation: true,
        updateContactEmailError: null,
      };
    }
    case UPDATING_BILLING_INFORMATION_SUCCESS: {
      const updatedBillingInfo = normalizeAddressInformation(action.payload);
      return {
        ...state,
        billingInformation: updatedBillingInfo,
        isUpdatingBillingInformation: false,
      };
    }
    case UPDATING_BILLING_INFORMATION_ERROR: {
      return {
        ...state,
        isUpdatingBillingInformation: false,
        updateBillingInformationErrors: action.payload,
      };
    }
    case IS_UPDATING_SHIPPING_INFORMATION: {
      return {
        ...state,
        isUpdatingShippingInformation: true,
      };
    }
    case UPDATING_SHIPPING_INFORMATION_SUCCESS: {
      return {
        ...state,
        shippingInformation: action.payload,
        isUpdatingShippingInformation: false,
        updateShippingInformationErrors: null,
      };
    }
    case UPDATING_SHIPPING_INFORMATION_ERROR: {
      return {
        ...state,
        isUpdatingShippingInformation: false,
        updateShippingInformationErrors: action.payload,
      };
    }

    case CHECKOUT_EMAIL_UPDATE_ERROR: {
      return {
        ...state,
        updateContactEmailError: action.payload,
      };
    }
    case SET_SHIPPING_METHOD: {
      return {
        ...state,
        shippingMethod: action.payload,
      };
    }
    case SAME_AS_BILLING_ADDRESS: {
      return {
        ...state,
        shippingSameAsBilling: action.payload,
      };
    }
    default:
      return state;
  }
};
